import { Meta } from '@/src/components/common/Meta';
import { JamRecentFeedback } from '@/src/components/game/JamRecentFeedback/JamRecentFeedback';
import { useJamChallengeDetails } from '@/src/store/jam-challenge-details.context';
import { useJamEventDetails } from '@/src/store/jam-event-details.context';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { useTranslation } from 'react-i18next';

export const JamRecentFeedbackPage: React.FC = () => {
  const { t } = useTranslation();
  const { event } = useJamEventDetails();
  const { selectedJamChallenge } = useJamChallengeDetails();

  const challengeTitle = selectedJamChallenge?.title ?? t(i18nKeys.meta.challenge.title);
  const eventTitle = event?.title ?? t(i18nKeys.meta.event.title);
  const pageTitle = `${t(i18nKeys.myJams.challenges.details.recentFeedback.title)} | ${challengeTitle} | ${eventTitle}`;

  return (
    <>
      <Meta title={pageTitle} />
      <JamRecentFeedback />
    </>
  );
};
